/* Flash sale countdown */
(function () {
  const pad = n => String(n).padStart(2, '0');

  function formatCountdown(ms) {
    if (ms <= 0) return null;
    const totalHours = Math.floor(ms / 3600000);
    const minutes    = Math.floor((ms % 3600000) / 60000);
    const seconds    = Math.floor((ms % 60000) / 1000);
    return `${pad(totalHours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  let intervalId;

  function updateCountdowns() {
    let hasActive = false;
    document.querySelectorAll('[data-expiration]').forEach(el => {
      const expiration = parseInt(el.dataset.expiration, 10) * 1000;
      const remaining  = expiration - Date.now();
      const timer      = el.querySelector('.sale-countdown__timer');
      if (!timer) return;
      const formatted  = formatCountdown(remaining);
      if (!formatted) {
        el.classList.add('hidden');
      } else {
        timer.textContent = formatted;
        hasActive = true;
      }
    });
    if (!hasActive && intervalId) clearInterval(intervalId);
  }

  updateCountdowns();
  intervalId = setInterval(updateCountdowns, 1000);
})();

/* Cart Promo Slider */
function cartPromoSlide(button, direction) {
  const wrapper = button.closest('.cart-promo__slider-wrapper');
  if (!wrapper) return;
  const track   = wrapper.querySelector('.cart-promo__products');
  if (!track) return;
  const card    = track.querySelector('.cart-recommendations-cart-item');
  if (!card) return;
  track.scrollBy({ left: direction * (card.offsetWidth + 8), behavior: 'smooth' });
  setTimeout(() => cartPromoUpdateArrows(wrapper), 350);
}

function cartPromoUpdateArrows(wrapper) {
  const track = wrapper.querySelector('.cart-promo__products');
  const prev  = wrapper.querySelector('.cart-promo__arrow--prev');
  const next  = wrapper.querySelector('.cart-promo__arrow--next');
  if (!track || !prev || !next) return;
  prev.disabled = track.scrollLeft <= 4;
  next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
}

function cartPromoSelectSize(button) {
  const product = button.closest('[data-promo-product]');
  const variants = product.querySelector('.cart-promo__variants');
  const btnSelect = product.querySelector('.cart-promo__btn-select');
  const btnAdd = product.querySelector('.cart-promo__btn-add');
  if (variants) variants.hidden = false;
  if (btnSelect) btnSelect.hidden = true;
  if (btnAdd) btnAdd.hidden = false;
}

function cartPromoPickVariant(button) {
  const product = button.closest('[data-promo-product]');
  const input = product.querySelector('.cart-promo__variant-input');
  if (input) input.value = button.dataset.variantId;
  product.querySelectorAll('.cart-promo__variant-btn').forEach(btn => {
    btn.classList.toggle('selected', btn === button);
  });
}

function cartPromoAdd(button) {
  const product = button.closest('[data-promo-product]');
  const input = product.querySelector('.cart-promo__variant-input');
  if (!input || !input.value) return;
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Añadiendo...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: input.value, quantity: 1 })
  })
    .then(r => {
      if (!r.ok) return r.json().then(err => { throw err; });
      return r.json();
    })
    .then(() => {
      button.textContent = '¡Agregado!';
      setTimeout(() => {
        const refresh = typeof refreshCartDrawer === 'function'
          ? Promise.resolve(refreshCartDrawer())
          : Promise.resolve();
        refresh.then(() => {
          if (typeof window._refreshPromoBar === 'function') window._refreshPromoBar();
        });
        button.disabled = false;
        button.textContent = originalText;
      }, 1000);
    })
    .catch(err => {
      console.error('Error al agregar:', err);
      button.disabled = false;
      button.textContent = originalText;
    });
}

/* Patch refreshCartDrawer to also re-render the .cart-promo section */
(function () {
  const _parser = new DOMParser();

  function refreshCartPromoSection() {
    return fetch('/cart')
      .then(r => r.text())
      .then(html => {
        const doc = _parser.parseFromString(html, 'text/html');
        const newPromo = doc.querySelector('.cart-promo');
        const host = document.querySelector('#CartDrawer-Pinflag') || document.querySelector('cart-drawer');
        if (!host) return;
        const current = host.querySelector('.cart-promo');
        if (newPromo) {
          if (current) {
            current.outerHTML = newPromo.outerHTML;
          } else {
            const recommendations = host.querySelector('cart-recommendations');
            const footer = host.querySelector('.drawer__footer');
            const anchor = recommendations || footer;
            if (anchor) anchor.insertAdjacentHTML('beforebegin', newPromo.outerHTML);
          }
        } else if (current) {
          current.remove();
        }
        if (typeof window._refreshPromoBar === 'function') window._refreshPromoBar();
      })
      .catch(() => {});
  }

  function patch() {
    const _orig = window.refreshCartDrawer;
    if (typeof _orig !== 'function') return;
    window.refreshCartDrawer = function () {
      return Promise.resolve(_orig()).then(refreshCartPromoSection);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch);
  } else {
    patch();
  }
})();

/* Cart Promo Bar – dynamic progress update */
(function () {
  function formatMoney(cents, format) {
    const amount = Math.round(cents / 100);
    return format.replace(/\{\{[\w_]+\}\}/g, amount.toLocaleString());
  }

  let _lastTotal = -1;
  let _debounceTimer;

  function updatePromoBar() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(doUpdate, 200);
  }

  function doUpdate() {
    const bar = document.querySelector('.cart-promo-bar');
    if (!bar) return;
    const promoMin = parseInt(bar.dataset.promoMin, 10) || 0;
    if (!promoMin) return;
    const moneyFormat = bar.dataset.moneyFormat || '${{amount}}';
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const total = cart.total_price;
        if (total === _lastTotal) return;
        _lastTotal = total;

        const unlocked = total >= promoMin;
        const pct      = unlocked ? 100 : Math.floor(total * 100 / promoMin);
        const fill     = bar.querySelector('.cart-promo-bar__fill');
        const text     = bar.querySelector('.cart-promo-bar__text');
        if (fill) fill.style.width = pct + '%';
        if (!text) return;
        const badge     = bar.dataset.promoBadge || '';
        const badgeHtml = badge ? `&nbsp;<span class="cart-promo-bar__badge">${badge}</span>` : '';
        if (unlocked) {
          text.classList.add('cart-promo-bar__text--done');
          const heading   = bar.dataset.promoHeading || '';
          const sep       = heading && badge ? ' &mdash; ' : '';
          const badgePart = badge ? `<strong>${badge}</strong>` : '';
          text.innerHTML = `${heading}${sep}${badgePart}&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>`;
        } else {
          text.classList.remove('cart-promo-bar__text--done');
          const remaining          = promoMin - total;
          const remainingFormatted = formatMoney(remaining, moneyFormat);
          const template = bar.dataset.promoText;
          text.innerHTML = template
            ? template.replace('{amount}', `<strong>${remainingFormatted}</strong>`) + badgeHtml
            : `Te faltan <strong>${remainingFormatted}</strong> para obtener${badgeHtml}`;
        }
      })
      .catch(() => {});
  }

  window._refreshPromoBar = function () {
    _lastTotal = -1;
    updatePromoBar();
  };

  function attachObserver() {
    updatePromoBar();
    const target = document.querySelector('cart-drawer') || document.getElementById('CartDrawer') || document.body;
    new MutationObserver(updatePromoBar).observe(target, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', window._refreshPromoBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
})();
